define('app/ss/site/details/ss-site-details',[], function () {
	return {
		controller: function () {

		}
	};
});
